import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo
} from 'react';

const CurrentApplicantContext = createContext();

const CurrentApplicantContextProvider = ({ children }) => {
  const [currentApplicant, setCurrentApplicant] = useState(null);

  useEffect(() => {
    fetch('/api/current_user')
      .then((response) => response.json())
      .then((payload) => {
        if (payload) {
          setCurrentApplicant(payload.applicant);
        }
      });
  }, []);

  const contextValue = useMemo(() => {
    return currentApplicant;
  }, [currentApplicant]);

  return (
    currentApplicant && (
      <CurrentApplicantContext.Provider value={contextValue}>
        {children}
      </CurrentApplicantContext.Provider>
    )
  );
};

const useCurrentApplicantContext = () => {
  const context = useContext(CurrentApplicantContext);
  if (context === undefined) {
    throw new Error(
      'useCurrentApplicantContext was used outside of its provider.  The component you would like to have access to the current applicant (or a parent component) must be wrapped with the CurrentApplicantContextProvider component.'
    );
  }
  return context;
};

export {
  CurrentApplicantContextProvider,
  useCurrentApplicantContext
};
